import months from './months'

const currentStatitics = (statistics) => {
  const monthNow = new Date()
  let statisticsCurrent = statistics.filter(function (items) {
    return items.schedule_month === monthNow.getMonth() + 1
  })

  return statisticsCurrent
}

export default {
  // Retornando valores mes atual por convenios, não esta incluido particulas
  afterPrepareShow () {
    if (currentStatitics(this.statistics)) {
      this.statistics = currentStatitics(this.statistics)
      if (this.statistics.length > 0) {
        this.currentMonth = months(this.statistics)
        this.scheduleYear = this.statistics[0].schedule_year
        this.total_by_covenants = this.statistics[0].total_by_covenants
        // verificar o valor de convenio
        if (this.total_by_covenants === '0') {
          this.ishidden = true
        }
      }
      let totalCovenant = currentStatitics(this.statistics).reduce((acc, item) => {
        return acc + item.total_by_covenants
      }, 0)

      this.total = totalCovenant.toFixed(2).replace('.', ',')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/summary-billing/resources/methods.js